<template>
    <div class="w-full bg-lightGrey-100 rounded-full flex justify-between"
         :class="[sizeClass]">
        <span v-for="i in 5" :key="i"
              :class="[i < score ? 'mr-2' : '', i <= score ? color : '', sizeClass]"
              class="w-1/5 rounded-full"></span>
    </div>
</template>

<script>
    export default {
        props: {
            score: {
                type: Number,
                default: 0
            },
            size: {
                type: String,
                default: 'md'
            }
        },
        computed: {
            color() {
                let color = '';
                switch (this.score) {
                    case 1: color = 'bg-risk-400'; break;
                    case 2: color = 'bg-risk-300'; break;
                    case 3: color = 'bg-risk-200'; break;
                    case 4: color = 'bg-risk-100'; break;
                    case 5: color = 'bg-primary-100'; break;
                }
                return color;
            },
            sizeClass() {
                return this.size === 'lg' ? 'h-3' : 'h-2';
            }
        }
    }
</script>
